import React from 'react';
import PropTypes from 'prop-types';
import { View, Text, StyleSheet, TouchableWithoutFeedback } from 'react-native';

import { defaultScale } from '../../utils/scaling';
import Theme from '../../theme';
import RadioButton from './RadioButton';

const RadioButtonGroup = ({ options, inactiveStyle, optionInfoContainer, radioOptionContainer ,containerStyle}) => (
    <View style={containerStyle}>
        {options.map(option => {
            return (
                <TouchableWithoutFeedback
                    key={option.name}
                    disabled={option.disabled}
                    onPress={option.setOption}>
                    <View style={[styles.radioOptionContainer, radioOptionContainer,containerStyle]}>
                        <RadioButton
                            inactiveStyle={inactiveStyle}
                            disabled={option.disabled}
                            isSelected={option.isSelected}
                            toggleSelection={option.setOption}
                        />
                        <View style={[styles.optionInfoContainer, optionInfoContainer]}>
                            <Text style={[styles.name, option.disabled && styles.disabledName, option.style && option.style]}>
                                {option.name}
                            </Text>
                            {option.description &&
                                <Text style={styles.description}>
                                    {option.description}
                                </Text>
                            }
                        </View>
                    </View>
                </TouchableWithoutFeedback>
            );
        })}
    </View>
);

RadioButtonGroup.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        isSelected: PropTypes.bool.isRequired,
        setOption: PropTypes.func.isRequired,
        description: PropTypes.string,
    })),
};

const styles = StyleSheet.create({
    radioOptionContainer: {
        paddingVertical: defaultScale(8),
        flexDirection: 'row',
        paddingTop: defaultScale(5),
    },
    optionInfoContainer: {
        flex: 1,
        paddingHorizontal: defaultScale(10),
    },
    name: {
        ...Theme.textStyle.bodyCopyReg,
        paddingBottom: defaultScale(10),
        color: Theme.GREY_DARK,
    },
    description: {
        ...Theme.textStyle.bodyCopyReg,
        color: Theme.GREY_MEDIUM,
    },
    disabledName: {
        color: Theme.GREY,
        fontFamily: Theme.CustomNormalItalic,
    }
});

export default RadioButtonGroup;
